<template>
  <!-- 累計計算コンポーネント(子) -->
  <div id="monthlydata">
      <CRow v-if="success.length">
        <ul>
          <li style="color: blue" v-for="well in success" :key="well">
            {{ "※" + well }}
          </li>
        </ul>
      </CRow>
      <CRow v-if="errors.length">
        <ul>
          <li class="preika-form-message" v-for="error in errors" :key="error">
            {{ "※" + error }}
          </li>
        </ul>
      </CRow>
      <CRow>
        <CCol>
          <div class="container px-0">
            <div class="table-responsive">
             <table class="table table-bordered w-auto mx-auto summary-leave-table">
                <tr>
                  <th>(日)</th>
                  <th nowrap>前月残</th>
                  <th nowrap>今月発生</th>
                  <th nowrap>今月消化</th>
                  <th nowrap>今月残</th>
                </tr>
                <tr>
                  <th
                    scope="row"
                    :rowspan="paidUnresolved ? 3 : 2"
                    style="color: black; background-color: white"
                  >
                    有給
                  </th>
                  <!--
                    その月の時点へ戻せなかった月（この月より後の勤務表が先に承認されていて、
                    戻す材料が足りない。back の RosterLeaveBalance が印を付ける）は、
                    前月残・今月発生・今月残を確定した数字として出さない。今月消化は日ごとの
                    勤怠から数えた値なので出す。
                  -->
                  <td>
                      <span v-if="paidUnresolved" class="paid-balance-cell">{{ unresolvedMark }}</span>
                      <span v-else class="paid-balance-cell">{{ paid }}</span>
                      <input type="hidden" :value="paid" />
                  </td>
                  <td>
                    <span v-if="paidUnresolved" class="paid-balance-cell">{{ unresolvedMark }}</span>
                    <span v-else class="paid-balance-cell">{{ get_paid }}</span>
                    <input type="hidden" :value="get_paid" />
                  </td>
                  <td>
                    <span>{{ usePaid }}</span>
                    <input type="hidden" :value="usePaid" />
                  </td>
                  <td>
                    <span v-if="paidUnresolved" class="paid-balance-cell">{{ unresolvedMark }}</span>
                    <span v-else class="paid-balance-cell">{{ savePaidDisplay }}</span>
                    <input type="hidden" :value="savePaidDisplay" />
                  </td>
                </tr>
                <tr v-if="paidUnresolved">
                  <td colspan="4" class="paid-unresolved-note">
                    <div class="paid-unresolved-note__text">{{ unresolvedMessage }}</div>
                  </td>
                </tr>
                <tr>
                <td colspan="4" style="text-align:center; font-weight:bold;">
                  <span :style="paidDaysUsedStyle">今期消化日数 {{ termPaidDaysUsedLabel }}</span>（付与月：{{ paidDaysAdd }}月）
                    <a
                      href="#"
                      class="help-icon help-icon-inline"
                      @click.prevent="openPaidLeaveRuleModal"
                      aria-label="有休付与ルールを表示"
                    >
                      ?
                    </a>
                  <span v-if="shouldWarnPaidDaysUsed" class="paid-used-warn"><br><b>付与月までに最低5日は消化して下さい</b></span>
                </td>
                </tr>
                <tr>
                  <th
                    scope="row"
                    style="color: black; background-color: white"
                  >
                    代休
                  </th>
                  <td>
                    <span>{{ instead }}</span>
                    <input type="hidden" :value="instead" />
                  </td>
                  <td>
                    <span>{{ get_instead }}</span>
                    <input type="hidden" :value="get_instead" />
                  </td>
                  <td>
                    <span>{{ useInstead }}</span>
                    <input type="hidden" :value="useInstead" />
                  </td>
                  <td>
                    <span>{{ saveInsteadDisplay  }}</span>
                    <input type="hidden" :value="saveInsteadDisplay" />
                  </td>
                </tr>
                <!--
                  代休に期限を設けている会社だけ出す。設けていない会社では
                  substituteExpiry が空のままなので、この行ごと出ない。
                -->
                <tr v-if="substituteExpiry.length > 0">
                  <th
                    scope="row"
                    style="color: black; background-color: white"
                  >
                    代休の期限
                  </th>
                  <td colspan="4" class="substitute-expiry">
                    <span
                      v-for="row in substituteExpiry"
                      :key="row.key"
                      class="substitute-expiry__item"
                    >{{ row.label }}</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </CCol>
        <CCol>
          <div class="container px-0">
            <div class="table-responsive">
             <table class="table table-bordered w-auto mx-auto">
                <tr>
                  <th nowrap>規定時間</th>
                  <th nowrap>時間外</th>
                  <th nowrap>夜勤</th>
                  <th nowrap>遅刻</th>
                  <th nowrap>規定勤務</th>
                </tr>
                <tr>
                  <td>
                    <span>{{ durationTime }}</span>
                    <input type="hidden" :value="durationTime" />
                  </td>
                  <td>
                    <span>{{ overTotal }}</span>
                    <input type="hidden" :value="overTotal" />
                  </td>
                  <td>
                    <span>{{ nightTotal }}</span>
                    <input type="hidden" :value="nightTotal" />
                  </td>
                  <td>
                    <span>{{ lateCount }}</span>回
                    <input type="hidden" :value="lateCount" />
                  </td>
                  <td>
                    <span>{{ duration }}</span>日
                    <input type="hidden" :value="duration" />
                  </td>
                </tr>
                <tr>
                  <!--
                    「作業」が時間と日数の2か所にあり、どちらを見ているのか
                    画面から区別できなかった。単位を付けて分ける。
                    日数は月次集計一覧（admin/total/List.vue）と同じ
                    「出勤日数」にして、2つの画面で同じ数字だと分かるようにする。
                  -->
                  <th nowrap>業務時間</th>
                  <th nowrap>欠勤</th>
                  <th nowrap>法定休日</th>
                  <th nowrap>早退</th>
                  <th nowrap>出勤日数</th>
                </tr>
                <tr>
                  <td>
                    <span>{{ actualTime }}</span>
                    <input type="hidden" :value="actualTime" />
                  </td>
                  <td>
                    <span>{{ absentTime }}</span>
                    <input type="hidden" :value="absentTime" />
                  </td>
                  <td>
                    <span>{{ holidayTotal }}</span>
                    <input type="hidden" :value="holidayTotal" />
                  </td>
                  <td>
                    <span>{{ earlyCount }}</span>回
                    <input type="hidden" :value="earlyCount" />
                  </td>
                  <td>
                    <span>{{ actual }}</span>日
                    <input type="hidden" :value="actual" />
                  </td>
                </tr>
              </table>
              <!--
                基準時間の判定は表の一部ではなく、この月ぜんたいの見立て。
                **以前は </tr> と </table> の間に置いていた。**
                table の直下に span は書けないので、ブラウザが表の外へ
                弾き出していた。どこへ出るかはエラー回復まかせで、
                下に取り残されたように見えていた。
                正しい位置へ移し、見出しの右へ並べる（CSS 側で配置）。
              -->
              <span
                class="work-time-status"
                :style="{ color: workTimeStatus.color }"
              >
                {{ workTimeStatus.text }}
              </span>
            </div>
          </div>
        </CCol>
      </CRow>
      <div v-if="!fromExternal">
        <CRow>
          <CCol class="text-center">
            <!-- 押せない理由（承認待ち・承認済み）を、表の上だけでなく［保存］のすぐ上にも出す。 -->
            <ActionResultMessage :text="lockReason" type="info" :reveal="false" />
            <save-button
              :class="'edit-form__submit-btn + btn btn-primary'"
              :label="'保存'"
              :loading="loading"
              :disabled="statusBtn || waiting"
              @click="register"
              />
            <br />※
            保存後、他月次申請とまとめて「自分の申請一覧」にて承認申請を行ってください。
          </CCol>
        </CRow>
      </div>
      <!-- 有休付与ルール（通常の労働者）モーダル --> 
      <!-- CoreUI 3.0.0 に CModalHeader / CModalBody は無い。題名は title（見出しの帯）へ、本文は既定のスロットへ置く。 -->
      <CModal
        title="有休付与ルール（通常）"
        :show.sync="showPaidLeaveRuleModal"
        @close="closePaidLeaveRuleModal"
        centered
        size="lg"                              
        class="paid-rule-modal"                
      >                                        

        <div class="paid-rule-modal-body"> 
          <div class="table-responsive"> 
            <table class="table table-bordered mb-0"> 
              <tr>
                <th class="plr-rowhead">継続勤務年数（年）</th>
                <th class="plr-colhead text-center">0.5</th>
                <th class="plr-colhead text-center">1.5</th>
                <th class="plr-colhead text-center">2.5</th>
                <th class="plr-colhead text-center">3.5</th>
                <th class="plr-colhead text-center">4.5</th>
                <th class="plr-colhead text-center">5.5</th>
                <th class="plr-colhead text-center">6.5以上</th>
              </tr>
              <tr>
                <th class="plr-rowhead">付与日数（日）</th>
                <td class="text-center">10</td>
                <td class="text-center">11</td>
                <td class="text-center">12</td>
                <td class="text-center">14</td>
                <td class="text-center">16</td>
                <td class="text-center">18</td>
                <td class="text-center">20</td>
              </tr>
            </table> 
          </div> 
          <!-- 注釈（上期/下期） --> 
          <div class="paid-rule-note mb-2">
            <div>【有休付与確認について】</div> 
            <div>本画面は報告対象月の有休データとなるので、付与された月に付与による増加分の有休消化は可能ですが</div>
            <div>付与日数の本画面上及び給与明細での確認は付与月の翌月提出時となります。</div> 
            <div>例：4月付与の場合は、5月月初提出時の4月勤務表にて付与表示</div>
            <div class="mt-2">【上期（4月1日基準）10月1日以降3月31日迄に入社した従業員の場合】</div> 
            <div>入社後に最初に到来する4月1日に勤続6か月とみなし、以降勤続年数に応じて上表のとおり付与となります。</div> 
            <div class="mt-2">【下期（10月1日基準）4月1日以降9月30日迄に入社した従業員の場合】</div> 
            <div>入社後最初に到来する10月1日に勤続6か月とみなし、以降勤続年数に応じて上表のとおり付与となります。</div> 
          </div> 
        </div> 

        <template #footer> 
          <button class="btn btn-secondary" @click="closePaidLeaveRuleModal">閉じる</button> 
        </template> 
      </CModal> 
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import ConstList from "./../ConstList";
import SaveButton from '../common/SaveButton';
import ActionResultMessage from '../components/ActionResultMessage.vue';
import { toApiTimeValue } from '../utils/timeValue';
import { backendErrorMessage } from '../utils/rosterActualPolicy';
import { countPaidLeaveDays } from '../utils/paidLeaveUsage';

// 案件の定時・休憩が時刻の形（"09:00"・"9:00"・"09:00:00"）か。
// 空・null・入っていない・ほかの文字は、時刻でない（月の規定時間の式で使う）。
const isTimeText = (value) =>
  typeof value === "string" && /^\d{1,2}:\d{2}(:\d{2})?$/.test(value);

export default {
  name: "MonthlyData",
  components: {
    SaveButton,
    ActionResultMessage,
  },
  data() {
    return {
      over: this.overTime || [],
      deducts: this.deduct || [],
      nights: this.nightWork || [],
      holidays: this.holiday || [],
      items: [],
      // 代休が「いつまでに何日」残っているか。期限を使わない会社では空のまま。
      substituteExpiry: [],
      late: "",
      early: "",
      take_paid: "",
      remain_paid: "",
      remain_instead: "",
      defined_day: "",
      sum_day: "",
      sum_time: "",
      sum_over: "",
      sum_deduction: "",
      sum_night: "",
      sum_holiday: "",
      success: [],
      errors: [],
      loading: false,
      submit_flg: false,
      showPaidLeaveRuleModal: false,
    };
  },
  props: {
    userId: Number,
    today: Array,
    fromExternal:Boolean,
    monthDay: Array,
    outBasic: String,
    startBasic: Array,
    endBasic: Array,
    breakBasic: Array,
    start: Array,
    end: Array,
    rest: Array,
    attendance1: Array,
    attendance2: Array,
    remarks: Array,
    // 勤務表（Roster.vue）は年・月と休暇の残数を数で渡す（back の値のまま）。中では Number(...) に
    // 直して使うので、どちらでも同じに動く。String だけだと開発時に型の警告が並んでいた。
    year: [String, Number],
    month: [String, Number],
    totalTime: Array,
    overTime: Array,
    holiday: Array,
    nightWork: Array,
    nightRest: Array,
    deduct: Array,
    earlyMorningShiftBasic: String,
    lateNightShiftBasic: String,
    midnightBasic: String,
    nightShiftTimes: String,
    dateChangeShiftTimes: String,
    paid: [String, Number],
    // 有給の前月残・今月発生・今月残を、その月の時点へ戻せなかった（back が印を付ける）。
    paidUnresolved: { type: Boolean, default: false },
    savePaid: String,
    paidDaysUsed: [String, Number],
    paidDaysAdd: [String, Number],
    saveInstead: String,
    get_paid: [String, Number],
    instead: [String, Number],
    addInstead: [String, Number],
    statusBtn: Boolean,
    // 勤務表に幕が出ているか（読み込み中・案件の設定の待ち・一括変更の待ち・保存の送信中）。
    // 出ているあいだは［保存］を止める。statusBtn へは混ぜない（statusBtn は代休の発生の出し方も切り替える）。
    waiting: { type: Boolean, default: false },
    // ［保存］が押せない理由（承認待ち・承認済み）。［保存］のすぐ上に出す。
    lockReason: { type: String, default: '' },
    /**
     * 保存の前に通す検証。
     *
     * **親の形に依存しない。**$parent.$refs を掴むと、
     * 置き場所を変えた日に黙って検証が消える。
     * 渡されなければ素通りする（他所で使われても壊れない）。
     */
    validateBeforeSave: { type: Function, default: null },
    baseTimeMin: Array,
    baseTimeMax: Array,
    projectId: Array,
    dailyVersion: Array,
  },
  methods: {
    /**
     * 代休が「いつまでに何日」残っているかを読む。
     *
     * **落ちても画面は止めない。**代休の期限は補足の情報で、
     * これが読めないせいで勤務表が開けなくなるほうが困る。
     */
    loadSubstituteExpiry () {
      /*
       * **見ている社員の、表示している月の時点の期限を出す。**
       * - 管理者がユーザー管理から開いた勤務表（Roster の fromExternal）：管理者用の口
       *   /admin/roster/substituteLeaveExpiry に、見ている社員（userId）と年月を渡す。
       *   前は本人用の口だけを呼んでいて、社員Aの勤務表に管理者本人の期限が出ていた。
       * - 本人の勤務表：本人用の口 /paidandsubstitute/substituteLeaveExpiry に年月を渡す。
       *   前は年月を渡さず、過去の月の勤務表にも今日の時点の期限が出ていた。
       * - その月の時点の内訳が残っていない月（back が history_available=false を返す。その月より後に
       *   積み直しがあった人）は、今の内訳を過去の月に出さないよう、行を出さない。
       *
       * **呼べなかったときも、返らなかったときも、同じく黙って諦める。**
       * mounted から呼ぶので、ここで投げると勤務表が丸ごと出なくなる。
       * 代休の期限は補足の情報で、これが理由で勤務表が開けないほうが困る。
       */
      const year = Number(this.year)
      const month = Number(this.month)
      if (!Number.isInteger(year) || !Number.isInteger(month)) {
        this.substituteExpiry = []
        return
      }
      // 管理者の勤務表詳細は、見ている社員が決まるまで呼ばない（決まる前に呼ぶと社員の指定の無い通信が 400 で返り、
      // それがあとから返ると、出すべき行まで消していた。2026-10-04 に画面で見つけた）。
      const viewedUser = Number(this.userId)
      if (this.fromExternal && !(Number.isInteger(viewedUser) && viewedUser > 0)) {
        this.substituteExpiry = []
        return
      }
      const seq = (this.substituteExpirySeq || 0) + 1
      this.substituteExpirySeq = seq
      let request = null
      try {
        request = this.fromExternal
          ? axios.get(process.env.VUE_APP_API_ORIGIN + "/admin/roster/substituteLeaveExpiry", {
            params: { user_id: viewedUser, year, month }
          })
          : axios.get(process.env.VUE_APP_API_ORIGIN + "/paidandsubstitute/substituteLeaveExpiry", {
            params: { year, month }
          })
      } catch (error) {
        this.substituteExpiry = []
        return
      }
      if (!request || typeof request.then !== "function") {
        this.substituteExpiry = []
        return
      }
      request
        .then((response) => {
          if (seq !== this.substituteExpirySeq) return // 社員や月を替えたあとに返った古い答えは使わない
          const data = response && response.data ? response.data : {}
          if (!data.expiry_flg || data.history_available === false || !Array.isArray(data.remaining)) {
            this.substituteExpiry = []
            return
          }
          this.substituteExpiry = data.remaining
            .filter((row) => row && row.expires_on && row.remaining_days > 0)
            .map((row) => ({
              grant_year_month: row.grant_year_month,
              key: String(row.grant_year_month) + ":" + String(row.expires_on),
              label: moment(row.expires_on).format("YYYY年M月D日")
                + "まで " + row.remaining_days + "日"
            }))
        })
        .catch(() => {
          if (seq === this.substituteExpirySeq) this.substituteExpiry = []
        })
    },
    calcTotal(tmpTime) {
      if (!tmpTime) return '00:00'
      if(typeof tmpTime === "undefined") return '00:00'
     let totalMinute = 0;
      for (var i = 0; i < tmpTime.length; i++)  {
        if (!tmpTime[i] || tmpTime[i] === "" || tmpTime[i] === null) continue;
        const timeList = tmpTime[i].split(":");
        if (timeList.length != 2) continue; // 不正なフォーマットはスキップ
        const hour = timeList[0];
        const minute = timeList[1];

        const hh = Number(hour);
        const mm = Number(minute);
        if (!Number.isFinite(hh) || !Number.isFinite(mm)) continue;
        totalMinute += Number(minute) + Number(hour)*60;
      }
      const hSum = Math.floor(totalMinute / 60);
      const mSum = totalMinute % 60;
      const hTotal = hSum < 10 ? "0" + hSum : hSum;
      const mTotal = mSum < 10 ? "0" + mSum : mSum;
      return hTotal + ":" + mTotal;
    },
    // 前月残（有給）のエラーチェック
    paid_error: function () {
      // if ((this.paid === "") && ((this.get_paid !== "") || (this.instead !== ""))) {
      //   this.errors.push("前月残(有給)を入力してください")
      // } else if ((this.paid !== "") && ((!this.paid.match(/^[0-9]*$/)) && (!this.paid.match(/^\d{1,2}.\d{1}$/)))) {
      //   this.errors.push('前月残(有給)は入力例のように、半角数字と記号のみを用いて入力してください')
      // }
    },
    // 今月発生（有給）のエラーチェック
    getPaid_error: function () {
      // if ((this.get_paid === "") && ((this.paid !== "") || (this.instead !== ""))) {
      //   this.errors.push("今月発生(有給)を入力してください")
      // }
      // if ((this.get_paid !== "") && ((!this.get_paid.match(/^[0-9]*$/)) && (!this.get_paid.match(/^\d{1,2}.\d{1}$/)))) {
      //   this.errors.push('今月生(有給)は入力例のように、半角数字と記号のみを用いて入力してください')
      // }
    },
    // 前月残（代休）のエラーチェック
    instead_error: function () {
      // if ((this.instead === "") && ((this.paid !== "") || (this.get_paid !== ""))) {
      //   this.errors.push("前月残(代休)を入力してください")
      // }
      // if ((this.instead !== "") && ((!this.instead.match(/^[0-9]*$/)) && (!this.instead.match(/^\d{1,2}.\d{1}$/)))) {
      //   this.errors.push('前月残(代休)は入力例のように、半角数字と記号のみを用いて入力してください')
      // }
    },
    /**
     * 利用者への知らせ。この画面では、今までどおり確認の小窓（alert）で出す。
     *
     * 呼び出しを1か所へ集めてあるのは、勤務表を画面に出さずに動かす包み
     * （RosterHeadless.js）が、小窓を出さずに文を受け取れるようにするため。
     */
    notify(message) {
      alert(message);
    },
    /**
     * その日（index は 0 始まり）の行を、保存の本文へ入れるか。
     *
     * この画面の［保存］は、月の全部の日を入れる（いつも true）。
     * 勤務表を画面に出さずに動かす包み（RosterHeadless.js）だけが、ここを差し替える。
     */
    includesDayInSaveBody() {
      return true;
    },
    /**
     * 保存の本文で「未来日なので時刻と計算の値を送らない日」を決める今日（'YYYY-MM-DD'）。
     *
     * この画面の［保存］は、端末の日付（今までどおり）。
     * 勤務表を画面に出さずに動かす包み（RosterHeadless.js）だけが、サーバの今日へ差し替える
     * （勤務表の表の側の「今日」＝ Roster.vue の rosterTodayKey と同じ日にそろえる）。
     */
    saveTodayKey() {
      return moment().format("YYYY-MM-DD");
    },
    // DBへ登録処理と更新処理メソッド
    //
    // 結果を返す（画面の［保存］は返り値を見ない。画面に出さずに動かす包みが、保存できたかを知るために使う）。
    //   { outcome: 'busy' }      保存の途中なので何もしなかった
    //   { outcome: 'invalid' }   入力欄の検証で止まった（送っていない）
    //   { outcome: 'saved' }     保存できた
    //   { outcome: 'failed', status, message }  保存できなかった（status は状態コード。応答が無ければ 0。message は知らせに出した文）
    // 知らせ・読み直しの合図・バッジの合図の順と中身は、返り値を足す前と同じ。
    //
    // 勤務表に幕が出ているあいだ（waiting）も、何もしない（{ outcome: 'busy' }）。ボタンは止めてあるが、
    // 入口でも止める（読み込みの途中や、案件の設定を待っているあいだの値を送らない）。
    // 送り始めと終わり（成功・失敗のどちらでも）を、勤務表へ知らせる（saving-change）。勤務表は、
    // 送信中も読み込み中と同じ幕を出して入力を止める（送信中に直した値は送られず、読み直しで消えていた）。
    register: async function () {
      if (this.submit_flg || this.waiting) return { outcome: 'busy' };

      // **通らなければ、ここで止める。**
      // 赤字は各欄の下に出ているので、ここで別の文言は出さない。
      if (this.validateBeforeSave) {
        const ok = await this.validateBeforeSave();
        if (!ok) return { outcome: 'invalid' };
      }

      this.submit_flg = true;
      this.loading = true;
      this.items = [];
      // 未来日を決める今日（この画面では端末の日付。今までと同じ moment() の今日）。
      const saveToday = moment(this.saveTodayKey(), "YYYY-MM-DD", true);
      let n = 0;
      while (n < this.monthDay.length) {
        if (!this.includesDayInSaveBody(n)) {
          n++;
          continue;
        }
        const day = n + 1 < 10 ? "0" + (n + 1) : n + 1;
        const formattedMonth = this.month < 10 ? "0" + this.month : this.month;
        const rowDate = moment(
          `${this.year}-${formattedMonth}-${day}`,
          "YYYY-MM-DD",
          true
        );
        const futureActual = rowDate.isAfter(saveToday, "day");
        const rowStart = futureActual ? null : (this.start[n] ? this.start[n] + ":00" : null);
        const rowEnd = futureActual ? null : (this.end[n] ? this.end[n] + ":00" : null);
        // 休憩候補を見えないまま実績保存しない。入力欄にある値だけを送る。
        const effectiveRest = this.rest[n] || null;
        const item = {
          // 開始時刻
          start_time: rowStart,
          // 終了時刻
          end_time: rowEnd,
          // 休憩時間
          break_time: futureActual || !effectiveRest ? null : effectiveRest + ":00",
          // 夜勤休憩
          night_rest: futureActual ? null : toApiTimeValue(this.nightRest[n]),
          // 勤怠1
          attendance_id1: this.attendance1[n],
          // 勤怠2
          attendance_id2: this.attendance2[n],
          // 作業内容
          remarks: this.remarks[n],
          // 勤務時間
          working_time: futureActual || !this.totalTime[n] ? null : this.totalTime[n] + ":00",
          // 時間外時間
          overtime_time: futureActual || !this.overTime[n] ? null : this.overTime[n] + ":00",
          // 休日出勤時間
          holiday_time: futureActual || !this.holiday[n] ? null : this.holiday[n] + ":00",
          // 夜勤時間
          night_time: futureActual || !this.nightWork[n] ? null : this.nightWork[n] + ":00",
          // 控除時間
          deduction_time: futureActual || !this.deduct[n] ? null : this.deduct[n] + ":00",
          // 年月日
          date: this.year + "-" + formattedMonth + "-" + day,
          // ユーザID
          user_id: this.userId,
          sum_leave_early: this.earlyCount,
          sum_late: this.lateCount,
          paid_holiday_pre: this.paid,
          paid_holiday_added: this.get_paid,
          paid_holiday_used: this.usePaid,
          paid_holiday_remain: this.savePaidDisplay,
          paid_days_used: this.termPaidDaysUsedValue,
          substitute_holiday_pre: this.instead,
          substitute_holiday_added: this.get_instead,
          substitute_holiday_used: this.useInstead,
          substitute_holiday_remain: this.saveInsteadDisplay,
          defined_attendance_day: this.duration,
          sum_attendance_day: this.actual,
          defined_work_time: this.durationTime,
          sum_work_time: this.actualTime,
          sum_over_time: this.overTotal,
          sum_deduction_time: this.absentTime,
          sum_night_time: this.nightTotal,
          sum_holiday_time: this.holidayTotal,
          project_id: this.projectId?.[n] ?? null,
          daily_version: this.dailyVersion?.[n] ?? null,
        };
        this.items.push(item);
        n++;
      }
      this.$emit('saving-change', true);
      return axios
        .post(process.env.VUE_APP_API_ORIGIN + "/update", this.items)
        .then(() => {          
          this.submit_flg = false;
          // 送信の終わりは、読み直しの合図より先に知らせる。読み直しが始まると、勤務表はこの部品を
          // いったん消して作り直すので、あとの finally からの知らせは届かない（幕が残って固まる）。
          // 読み直しの幕（loading）がすぐ続くので、幕は途切れない。
          this.$emit('saving-change', false);
          this.$emit('updateAllData');
          this.$store.commit('set', ['sidebarBadgeRefreshTick', Date.now()]);
          this.notify(ConstList.REGISTER_MESSAGE);
          return { outcome: 'saved' };
        })
        .catch((error) => {
          this.submit_flg = false;
          const status = error && error.response ? Number(error.response.status) : 0;
          const message = backendErrorMessage(
            error,
            status ? ConstList.SYSTEM_ERROR : ConstList.SYSTEM_COMMUNICATION_ERROR
          );
          this.notify(message);
          if (status === 409) {
            // 成功のときと同じく、読み直しの合図より先に送信の終わりを知らせる。
            this.$emit('saving-change', false);
            this.$emit('updateAllData');
          }
          return { outcome: 'failed', status, message };
        })
        .finally(() => {
          this.submit_flg = false;
          this.loading = false;
          // 終わりの知らせは、成功・失敗のどちらでも通るここにも置く（断られて読み直さないときに
          // 幕が残って固まらない）。読み直しの合図の前に知らせた道では、2回目になるだけ。
          this.$emit('saving-change', false);
        });
    },
    hmToMinutes(v) {
      if (v === null || v === undefined) return NaN;
      const s = String(v).trim();
      if (s === '') return NaN;

      // "H:MM" 形式
      if (s.includes(':')) {
        const [h, m = '0'] = s.split(':');
        const hh = Number(h);
        const mm = Number(m);
        if (!Number.isFinite(hh) || !Number.isFinite(mm)) return NaN;
        return hh * 60 + mm;
      }

      // 数字だけの場合 → 「時間」と解釈する
      const hh = Number(s);
      if (!Number.isFinite(hh)) return NaN;
      return hh * 60;   // ★ ここを「分」ではなく「時間→分」に修正
    },

    formatDiff(mins) {
      const abs = Math.abs(mins);
      const h = Math.floor(abs / 60);
      const m = abs % 60;
      // 分は必ず2桁表示
      return `${h}:${m.toString().padStart(2, '0')}`;
    },
    openPaidLeaveRuleModal: function () {
      this.showPaidLeaveRuleModal = true;
    },
    closePaidLeaveRuleModal: function () {
      this.showPaidLeaveRuleModal = false;
    },
  },
  watch: {
    // 見ている社員・表示している月が替わったら、その社員のその月の時点の期限を読み直す。
    userId () { this.loadSubstituteExpiry() },
    year () { this.loadSubstituteExpiry() },
    month () { this.loadSubstituteExpiry() },
    totalTime: {
      immediate: true,
      handler() {
        this.updateCalculations?.();
      },
    },
    holiday: {
      immediate: true,
      handler() {
        this.holidays = this.holiday;
      }
    },
    deduct: {
      immediate: true,
      handler() {
        this.deducts = this.deduct;
      }
    }
  },
  mounted () {
    this.loadSubstituteExpiry()
  },

  computed: {
    total() {
    return this.totalTime || []; 
  },
    // 遅刻数の計算
    lateCount: function () {
      let count = 0;
      this.start.forEach((value, i) => {
        const sTime = moment.duration(value, "HH:mm");
        const sBase = moment.duration(this.startBasic[i], "HH:mm");
        if (sBase.hours() === 0 && sBase.minutes() === 0) {
          return count;
        }
        const diff = sTime.subtract(sBase);
        if (
          diff > 0 &&
          this.attendance1[i] !== ConstList.SHIFT &&
          this.attendance2[i] !== ConstList.SHIFT &&
          this.attendance1[i] !== ConstList.HOLIDAY &&
          this.attendance1[i] !== ConstList.MORNING_PAID &&
          this.attendance1[i] !== ConstList.MORNING_SUBSTITUTE &&
          this.attendance1[i] !== ConstList.MORNING_SPECIAL_HOLIDAY &&
          // 午前欠勤は休暇申請を出した半日。**遅刻ではない。**
          // 休んだぶんは控除（Deduction.vue）で引いている。
          this.attendance1[i] !== ConstList.MORNING_DEDUCTION
        ) {
          count++;
        }
      });
      // const list = this.late
      // list.splice(0, 1, count)
      return count;
    },
    // 早退数の計算
    earlyCount: function () {
      let count = 0;
      this.end.forEach((value, i) => {
        const eTime = moment.duration(value, "HH:mm");
        const eBase = moment.duration(this.endBasic[i], "HH:mm");
        if (eTime.hours() === 0 && eTime.minutes() === 0) {
          return count;
        }
        const diff = eBase.subtract(eTime);
        if (
          diff > 0 &&
          this.attendance1[i] !== ConstList.SHIFT &&
          this.attendance2[i] !== ConstList.SHIFT &&
          this.attendance1[i] !== ConstList.HOLIDAY &&
          this.attendance2[i] !== ConstList.AFTERNOON_PAID &&
          this.attendance2[i] !== ConstList.AFTERNOON_SUBSTITUTE &&
          this.attendance2[i] !== ConstList.AFTERNOON_SPECIAL_HOLIDAY &&
          // 午後欠勤は休暇申請を出した半日。**早退ではない。**
          this.attendance2[i] !== ConstList.AFTERNOON_DEDUCTION
        ) {
          count++;
        }
      });
      // const list = this.early
      // list.splice(0, 1, count)
      return count;
    },
    // 有給の前月残・今月発生・今月残をその月の時点へ戻せなかったときに、数字の代わりに出す印。
    unresolvedMark: function () {
      return '—';
    },
    // 同じとき、有給の欄の下に出す文（Gemini で決めた文）。
    unresolvedMessage: function () {
      return ConstList.PAID_UNRESOLVED_MESSAGE;
    },
    // 有給消化の計算
    // **承認で差し引く日数と同じ数え方にする**（2026-09-30 の仕様 B）。
    // 前は 午前有給＋午後有給 を 0.5日、有給＋午後有給 を 1.5日 と数えていた。
    // 数え方は utils/paidLeaveUsage.js（午前・午後の枠で数え、1日を超えない）。
    usePaid: function () {
      return countPaidLeaveDays(this.attendance1, this.attendance2);
    },
    // 今月残有給の計算
    savePaidCalc: function () {
      const last = Number(this.paid ?? 0);
      const get = Number(this.get_paid ?? 0);
      const take = Number(this.usePaid ?? 0);
      const total = last + get - take;
      return total.toFixed(1); // 小数あり得るため
    },
    savePaidDisplay: function () {
      return (this.savePaid !== null && this.savePaid !== undefined && this.savePaid !== "")
        ? this.savePaid
        : this.savePaidCalc;
    },
    //代休発生の計算
    // 代休発生の計算（休日しきい値ルール：4h/8h）
    get_instead: function () {
      if (this.statusBtn) {
        return this.addInstead;
      }
      let count = 0;

      this.attendance1.forEach((att, i) => {
        if (att !== ConstList.HOLIDAY) return;

        // 実働（"HH:mm"）→ 分に変換。未入力/nullは除外
        const workStr = (this.total && this.total[i]) || (this.totalTime && this.totalTime[i]) || "";
        const workMin = this.hmToMinutes(workStr);
        if (!Number.isFinite(workMin)) return;

        // しきい値（分）
        const HALF_DAY_MIN = 240; // 4h
        const FULL_DAY_MIN = 480; // 8h

        if (workMin >= FULL_DAY_MIN) {
          // 8時間ちょうど／以上 → 1.0 日
          count += 1.0;
        } else if (workMin >= HALF_DAY_MIN) {
          // 4時間ちょうど／超〜8時間未満 → 0.5 日
          count += 0.5;
        }
        // 4時間未満 → 代休なし（0）
      });

      return count;
    },

    // 代休消化の計算
    useInstead: function () {
      let count = 0;
      this.attendance1.forEach((value, i) => {
        if (count < 0) {
          return count;
        }
        if (value === ConstList.SUBSTITUTE) {
          count++;
        }
        if (
          value === ConstList.MORNING_SUBSTITUTE ||
          this.attendance2[i] === ConstList.AFTERNOON_SUBSTITUTE
        ) {
          count = count + 0.5;
        }
      });
      // const list = this.take_instead
      // list.splice(0, 1, count)
      return count;
    },
    // 今月残代休の計算
    saveInsteadCalc: function () {
      const last = Number(this.instead ?? 0);
      const get = Number(this.get_instead ?? 0);
      const take = Number(this.useInstead ?? 0);
      const total = last + get - take;
      return total.toFixed(1);
    },
    saveInsteadDisplay: function () {
      return (this.saveInstead !== null && this.saveInstead !== undefined && this.saveInstead !== "")
        ? this.saveInstead
        : this.saveInsteadCalc;
    },
    // 規定勤務日数の計算
    duration: function () {
      let count = 0;
      this.attendance1.forEach((value) => {
        if (value !== "" && value !== ConstList.HOLIDAY) {
          count++;
        }
      });
      return count;
    },
    // 規定勤務時間の計算
    durationTime: function () {
      // どこか1日でも「不正 or 案件の基準が無い（休憩が空など）」があれば、元の挙動どおり全体を "00:00" にする
      for (let i = 0; i < this.attendance1.length; i++) {
        if (this.attendance1[i] === ConstList.HOLIDAY) continue;

        const s = moment.duration(this.startBasic[i], "HH:mm");
        const e = moment.duration(this.endBasic[i],   "HH:mm");
        const b = moment.duration(this.breakBasic[i], "HH:mm");

        const diffCheck = e.clone().subtract(s).subtract(b);

        // 休憩は文字で見る。サーバは、案件に休憩が無い（基準が取れない）日を ""、
        // 休憩なしの案件（午前だけの案件など）の日を "00:00" で返す。
        // 時と分の数字で見ると両方が 0 になり、休憩なしの案件の日が1日あるだけで
        // 月ぜんたいが 00:00 になっていた（2026-10-02）。
        // 休憩が 0 と読める日を数えるのは、開始・終了・休憩が全部時刻でそろっている日
        // （休憩なしの案件の日）だけ。休憩が空・null・入っていない日と、開始か終了が空の日は、
        // 今までどおり止める（案件の基準が無い日を、休憩なしとして数えない）。
        // 休憩が 0 でない日の扱いは、前のまま変えない。
        const breakIsZero = b.hours() === 0 && b.minutes() === 0;
        const standardIsComplete =
          isTimeText(this.startBasic[i]) &&
          isTimeText(this.endBasic[i]) &&
          isTimeText(this.breakBasic[i]);

        if (
          diffCheck.asMinutes() <= 0 ||                 // 負/ゼロ（不正）
          (breakIsZero && !standardIsComplete)          // 休憩が 0 で、案件の基準がそろっていない日
        ) {
          return "00:00";
        }
      }

      // 全日OKなら、各日の基準(終-始-休)を合算
      let totalMinutes = 0;
      for (let i = 0; i < this.attendance1.length; i++) {
        if (this.attendance1[i] === ConstList.HOLIDAY) continue;

        const s = moment.duration(this.startBasic[i], "HH:mm");
        const e = moment.duration(this.endBasic[i],   "HH:mm");
        const b = moment.duration(this.breakBasic[i], "HH:mm");
        const diff = e.clone().subtract(s).subtract(b); // ここは健全値のみ

        totalMinutes += diff.hours() * 60 + diff.minutes();
      }

      const hTotal = Math.floor(totalMinutes / 60);
      const mTotal = totalMinutes % 60;

      return (
        (hTotal < 10 ? "0" + hTotal : hTotal) +
        ":" +
        (mTotal < 10 ? "0" + mTotal : mTotal)
      );
    },
    // 実務日数の計算
    totalForCalc() {
    return this.totalTime || [];
    },
    actual() {
      return (this.totalTime || []).filter(val => !!val).length;
    },
    actualTime() {
      return this.calcTotal(this.totalTime || []);
    },
    // 時間外時間の計算
    overTotal: function () {
      return this.calcTotal(this.overTime || []);
    },
    // 欠勤時間の計算
    absentTime: function () {
      return this.calcTotal(this.deduct || []);
    },
    // 夜勤時間の計算
    nightTotal: function () {
      return this.calcTotal(this.nightWork || []);
    },
    // 休日時間の計算
    holidayTotal: function () {
      return this.calcTotal(this.holiday || []);
    },
    termPaidDaysUsedValue() {
      const base = Number(this.paidDaysUsed ?? 0);
      const add  = Number(this.usePaid ?? 0);     
      const v = base + add;
      return Number.isFinite(v) ? v : 0;
    },
    termPaidDaysUsedLabel() {
      const v = this.termPaidDaysUsedValue;
      return Number.isInteger(v) ? String(v) : v.toFixed(1);
    },
    // 有給消化不足警告色付け
    paidDaysUsedStyle() {
      const v = Number(this.termPaidDaysUsedValue);
      if (!Number.isFinite(v)) return { color: 'black' };
      if (v < 3) return { color: 'red' };
      if (v < 5) return { color: 'orange' };
      return { color: 'black' };
    },
    // 有給消化不足警告文
    shouldWarnPaidDaysUsed() {
      const v = Number(this.termPaidDaysUsedValue);
      if (!Number.isFinite(v)) return false;
      return v < 5;
    },
    workTimeStatus() {
      const totalMin = this.hmToMinutes(this.actualTime);
      const minMin   = this.hmToMinutes(this.baseTimeMin[0]);
      const maxMin   = this.hmToMinutes(this.baseTimeMax[0]);

      const hasTotal = Number.isFinite(totalMin);
      const hasMin   = Number.isFinite(minMin);
      const hasMax   = Number.isFinite(maxMin);
      const BAND5H   = 5 * 60;

      // total 未入力や不正な場合のみ「基準時間内」
      if (!hasTotal) return { text: '基準時間内', color: 'green' };

      if (!hasMin && !hasMax) return { text: '基準時間内', color: 'green' };

      if (hasMax && totalMin > maxMin) {
        return { text: `【超過】${this.formatDiff(totalMin - maxMin)}`, color: 'red' };
      }
      if (hasMin && totalMin < minMin) {
        return { text: `【不足】${this.formatDiff(minMin - totalMin)}`, color: 'blue' };
      }
      // 上限 - 5H 以内 → オレンジ
      if (hasMax && totalMin >= (maxMin - BAND5H) && totalMin <= maxMin) {
        return { text: '基準時間内', color: 'orange' };
      }
      // 下限 + 5H 以内 → 水色
      if (hasMin && totalMin >= minMin && totalMin <= (minMin + BAND5H)) {
        return { text: '基準時間内', color: '#00BFFF' }; // water-light（お好みで 'deepskyblue' でも可
      }
      return { text: '基準時間内', color: 'green' };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/* サマリテーブル共通スタイル */
table th {
  text-align: center;
  vertical-align: middle;
}

table td {
  text-align: center;     /* データは中央寄せ */
  vertical-align: middle; /* 上下中央 */
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

button:disabled {
  cursor: not-allowed;
}

.summary-leave-table th[scope="row"] {
  width: 40px;            /* 有休・代休列だけ狭める。40〜60pxで調整可 */
  white-space: nowrap;    /* 折り返し防止 */
  text-align: center;     /* 中央寄せ */
  padding-left: 2px;      /* 余白を最小限に */
  padding-right: 2px;
}

/* 期限は複数並ぶ。折り返しても読めるように間隔を置く。 */
.substitute-expiry {
  text-align: left;
  white-space: normal;
}

.substitute-expiry__item {
  display: inline-block;
  margin-right: 0.75rem;
  white-space: nowrap;
}

/* その月の時点へ戻せなかった月の注意。表の幅を広げないように折り返す。 */
.paid-unresolved-note {
  text-align: left;
  white-space: normal;
}

.paid-unresolved-note__text {
  max-width: 22rem;
  font-size: 0.85rem;
  color: #c0392b;
}
</style>
